import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class IntegracoesTelefoniaService {
  private apiUrl = environment.apiGestorUrlLocal;
  private apiUrlNova = environment.apiGestorUrlNova;
  httpOptions = {
    headers: new HttpHeaders({ 
      'Content-Type': 'application/json', 
      'authorization': '',
      'session': '' 
    }),
    params: {}
  };

  constructor(
    private http: HttpClient,
    private tokenService: TokenService
  ) {
    this.atualizaHeaders();
  }

  atualizaHeaders(): void {
    this.httpOptions.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': this.tokenService.getToken(),
      'session': this.tokenService.getSessionUsuario()
    });
  }

  listar(filtros: any, paginacao: any): Observable<any> {
    this.atualizaHeaders();
    this.httpOptions.params = {
      pagina: paginacao.pagina || 1,
      total_registros: paginacao.por_pagina || 25,
      ...filtros
    };

    if (paginacao.order_by) {
      this.httpOptions.params['order_by'] = paginacao.order_by;
      this.httpOptions.params['is_descending'] = paginacao.is_descending;
    }

    return this.http.get(`${this.apiUrl}api/integracoes-telefonia`, this.httpOptions);
  }

  buscarPorId(integracao_id: number): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.get(`${this.apiUrl}api/integracoes-telefonia/${integracao_id}`, options);
  }

  criar(payload: any): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.post(`${this.apiUrl}api/integracoes-telefonia`, payload, options);
  }

  editar(integracao_id: number, payload: any): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.put(`${this.apiUrl}api/integracoes-telefonia/${integracao_id}`, payload, options);
  }

  deletar(integracao_id: number): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.delete(`${this.apiUrl}api/integracoes-telefonia/${integracao_id}`, options);
  }

  alterarStatus(integracao_id: number, payload: any): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.patch(`${this.apiUrl}api/integracoes-telefonia/${integracao_id}/status`, payload, options);
  }

  executarLigacao(payload: any): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.post(`${this.apiUrl}api/telefonia/ligar`, payload, options);
  }

  migrarIntegracoesAntigas(): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.post(`${this.apiUrl}api/empresa/script-migrar-integracoes-telefonia`, {}, options);
  }

  dropdownMacros(): Observable<any> {
    this.atualizaHeaders();
    const options = {
      headers: this.httpOptions.headers
    };
    return this.http.post(`${this.apiUrl}api/integracoes-telefonia/dropdown-macros`, {}, options);
  }
}


